import React from 'react';
import { Grid, useTheme } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useAppContext } from 'hooks/useAppContext';
import { Delay } from 'classes';
import { getDelays } from 'utils/DelayUtils';
import withAppStylesGrid from 'HOCs/withAppStyles';
import SkeletonGrid from 'components/Shared/SkeletonGrid';


function DelayDataTable({ customFilter }) {
  const title = "Delays";
  const theme = useTheme();
  const { selectedProject } = useAppContext();
  const columns = Delay.columns;
  console.log(customFilter)

  const WrappedGrid = (props) => {
    const Wrapped = withAppStylesGrid(MaterialTable, {
      projectID: selectedProject, getRecords: getDelays, theme, defaultFilters: {
        ProjectId_WorkItem: selectedProject,
        ...customFilter
      }
    })

    return <Wrapped {...props} />
  }
    
  
    return (
    selectedProject && theme ?
      <>
        <Grid container>
          <Grid item xs={12}>
            <WrappedGrid
              columns={columns}
              title={title}
              options={{
                pageSize: 15,
                pageSizeOptions: [15, 20, 25],
                padding: 'dense'
              }}
            />
          </Grid>

        </Grid>
      </>
      : <SkeletonGrid title={title} />
  )
}

export default DelayDataTable;